import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-[#F7F2E7] py-20 px-6" style={{
    backgroundColor: "#F7F2E7",
    backgroundImage: "none"
  }} data-id="element-123" data-mp="4vs1604r2hrx">
      <div className="max-w-3xl mx-auto" data-id="element-124" data-mp="9wfpuf5iamiz">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border-2 border-[#C9A24B] rounded-2xl p-8 md:p-12 text-center shadow-lg" data-id="element-125" data-mp="etz59idxx5ci">
          <div className="flex justify-center mb-6" data-id="element-126" data-mp="sl444i9hhtls">
            <div className="relative" data-id="element-127" data-mp="slmba9xops8h">
              <div className="w-24 h-24 rounded-full bg-gradient-to-br from-[#C9A24B] to-[#E0B756] flex flex-col items-center justify-center text-[#0A1535] shadow-md" data-id="element-128" data-mp="xjntytr77pjf">
                <ShieldCheck className="w-9 h-9" data-id="element-129" data-mp="12gxim76rjx67" />
                <span className="text-xs font-bold mt-0.5" data-id="element-130" data-mp="17hbtdwzr1l7x">7 DÍAS</span>
              </div>
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-[#0A1535] mb-4" data-id="element-131" data-mp="25ti5kiflimzh">
            Garantía de satisfacción de 7 días
          </h2>

          <p className="text-lg text-[#0A1535]/80 leading-relaxed mb-4" data-id="element-132" data-mp="1vtraofn4i5yv">
            Tu compra está 100% protegida. Comienza el Método R.E.V.E.L.A. hoy y
            vívelo sin ningún riesgo durante 7 días completos.
          </p>

          <p className="text-lg text-[#0A1535]/80 leading-relaxed mb-6" data-id="element-133" data-mp="2oiog3i68k8a7">
            Si dentro de los primeros 7 días sientes que este programa no es
            para ti, solicita tu reembolso a través de Hotmart y te devolvemos
            el 100% de tu inversión — sin preguntas, sin complicaciones.
          </p>

          <p className="text-base font-semibold text-[#C9A24B]" data-id="element-134" data-mp="2aq8kv3jkteju">
            Procesado de forma segura por Hotmart, la plataforma líder en
            productos digitales.
          </p>
        </motion.div>
      </div>
    </section>;
}